module.exports = __webpack_public_path__ + "static/media/node.d2f74766.png";